var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 48.346,
    viewBox: "0 0 50 48.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #21cd5b;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconos-01",
    transform: "translate(-0.95 -1.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7625",
    "data-name": "Path 7625",
    className: "cls-1",
    d: "M27.208,49.408a23.365,23.365,0,0,1-11.456-3L6.893,49.123a4.551,4.551,0,0,1-4.9-1.525A4.757,4.757,0,0,1,1.5,42.405l3.95-7.486a24.265,24.265,0,0,1-1.986-9.685A23.989,23.989,0,0,1,27.208,1.062,23.986,23.986,0,0,1,50.951,25.235,23.986,23.986,0,0,1,27.208,49.408ZM16.473,40.583l1.01.639a18.166,18.166,0,0,0,9.725,2.821A18.663,18.663,0,0,0,45.681,25.235,18.663,18.663,0,0,0,27.208,6.427,18.663,18.663,0,0,0,8.734,25.235a18.881,18.881,0,0,0,2.015,8.54l.628,1.253L6.9,43.52l9.576-2.933Z",
    transform: "translate(0 0.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7626",
    "data-name": "Path 7626",
    className: "cls-2",
    d: "M30.681,23.381c-1.007-.6-2.32-1.278-3.51-.789-.911.375-1.5,1.8-2.084,2.529a.871.871,0,0,1-1.129.244,15.93,15.93,0,0,1-7.937-6.8.978.978,0,0,1,.122-1.33,5.386,5.386,0,0,0,1.443-2.342,5.122,5.122,0,0,0-.645-2.769c-.48-1.029-1.012-2.5-2.045-3.083a2.8,2.8,0,0,0-3.044.454,6.179,6.179,0,0,0-2.141,4.893A6.877,6.877,0,0,0,9.9,15.941a12.906,12.906,0,0,0,1.491,3.432,25.688,25.688,0,0,0,1.557,2.364A23.994,23.994,0,0,0,19.7,28,20.57,20.57,0,0,0,23.9,30c1.648.545,3.118,1.112,4.9.772a5.929,5.929,0,0,0,4.439-3.3,2.876,2.876,0,0,0,.2-1.683c-.253-1.16-1.823-1.853-2.765-2.412Z",
    transform: "translate(6.245 5.409)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.eabc6fb76ad6af010d456e62c54af100.svg";
export { ForwardRef as ReactComponent };